export enum ResultVisualization {
  GRAPH = 'Graph',
  CARDS = 'Cards',
}
